export default __webpack_public_path__ + "static/media/99.42a00995.jpeg";